













































import i18n from "@/i18n";
import { VerifyBoxVue } from "fs-pb-vue2/vueModels/app/VerifyBoxVue";
import { Component } from "vue-property-decorator";

@Component({})
export default class VerifyBox extends VerifyBoxVue {

  get getTimerText(): string {
    if (this.veriCodetimerVal / 60 > 1) {
      const mins = Math.trunc(this.veriCodetimerVal / 60);
      const secs = this.veriCodetimerVal - (mins * 60);
      return i18n
        .t("main.operation.form.repeatCodeTimerText", {
          timer: `${mins < 10 ? '0' + mins : mins} : ${secs < 10 ? '0' + secs : secs}`,
          seconds: ''
        })
        .toString()
    }
    const resTime =
      this.veriCodetimerVal >= 10
        ? this.veriCodetimerVal
        : "0" + this.veriCodetimerVal;
    return i18n
      .t("main.operation.form.repeatCodeTimerText", {
        timer: resTime,
        seconds: this.sklonenie(this.veriCodetimerVal, [
          "секунду",
          "секунды",
          "секунд"
        ])
      })
      .toString();
  }

  /** При создании присваеваем внешнее значение кода внутрненему */
  created() {
    this.modelValue = this.value;
    this.getDefaultTimerValue();
  }
  /** После создания запускаем таймеры и отображаем таймер на дисплей */
  mounted() {
    this.initTimers();
    this.getTimerValue();
  }
  /** Перед закрытыием опустощаем значение кода, чистим все таймеры */
  beforeDestroy() {
    this.modelValue = "";
    this.clearTimers();
    clearTimeout(this.veriCodetimer);
  }
}
